export default __webpack_public_path__ + "static/media/marin3.aebe338f.jpg";